/* eslint-disable no-shadow */
export enum ProxyServerHealthStatuses {
  Working = 'working',
  Checking = 'checking',
  NotWorking = 'notWorking'
}

export enum ProxyServerConfigurationStatuses {
  Configured = 'configured',
  Configurating = 'configurating',
  Checking = 'checking',
  NotConfigured = 'notConfigured',
  Unknown = 'unknown'
}

export enum ProxyServerAddressesGatewayKeys {
  UpdateHealthStatus = 'updateHealthStatus',
  UpdateConfigurationStatus = 'updateConfigurationStatus'
}
